import ajax from '../ajax'
// //上传完的回调
export function completeUploadApi(params) {
    return ajax({
        method:'get',
        url: '/manage/finish',
        params
    })
}

// //开始上传
export function startUploadApi(url,FormData) {
    return ajax({
        method:'post',
        url: url,
        data:FormData
    })
}

//获取上传签名
export function UploadSignatureApi(data) {
    return ajax({
        method:'post',
        url: '/manage/sign',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/uploadApi/index.js